 import Component from 'inferno-component';
import { Grid, Header, Divider, Container } from 'semantic-ui-react';
import ContactItem from './ContactItem';

export default class Contacts extends Component {
  render() {
    return (
      <Container id="kapcsolat" fluid className="smt spb ui container" style={{backgroundColor: '#212121', color: 'white'}}>
        <Container style={{paddingTop: '20px'}}>
          <Grid.Row centered>
            <Grid.Column>
              <Divider horizontal><Header as='h3' style={{color: 'white'}}>Kapcsolat</Header></Divider>
            </Grid.Column>
          </Grid.Row>
          <Grid columns={2} style={{paddingBottom: '20px'}} centered relaxed stackable verticalAlign='middle' className="fp">
            <Grid.Row>
              <ContactItem
                  name='phone'
                  color='white'
              >
                <p style={{fontSize: '1.1rem', textAlign: 'center'}}>
                    +36&nbsp;30&nbsp;779&nbsp;6766
                </p>
              </ContactItem>
              <ContactItem
                  name='mail'
                  color='white'
              >
                <p style={{fontSize: '1.1rem', textAlign: 'center'}}>
                    iroda@univadvert.hu
                </p>
              </ContactItem>
            </Grid.Row>
          </Grid>
        </Container>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/Contacts.js